// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — CallForm.styled.classic.js, новая — CallForm.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './CallForm.styled.classic';
import * as cp from './CallForm.styled.cp';

export const CallsWrapper = isCp ? cp.CallsWrapper : classic.CallsWrapper;
export const CheckBox = isCp ? cp.CheckBox : classic.CheckBox;
export const CheckboxRow = isCp ? cp.CheckboxRow : classic.CheckboxRow;
export const CheckboxWrapper = isCp ? cp.CheckboxWrapper : classic.CheckboxWrapper;
export const NodeCheckBox = isCp ? cp.NodeCheckBox : classic.NodeCheckBox;
export const PaymentCheckboxBlock = isCp ? cp.PaymentCheckboxBlock : classic.PaymentCheckboxBlock;
export const RackCheckBox = isCp ? cp.RackCheckBox : classic.RackCheckBox;
export const RacksCheckboxBlock = isCp ? cp.RacksCheckboxBlock : classic.RacksCheckboxBlock;
export const TurnOnSpeaker = isCp ? cp.TurnOnSpeaker : classic.TurnOnSpeaker;
